import { render, staticRenderFns } from "./TakipHazirlaView.vue?vue&type=template&id=0bf37e28"
import script from "./TakipHazirlaView.vue?vue&type=script&lang=ts"
export * from "./TakipHazirlaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports